import { CargoType } from "dora-contracts";

const cargoTypesWithContainerNo: CargoType[] = [
  "CONTAINER",
  "20_FEET",
  "20_FEET_HIGH_CUBE",
  "40_FEET",
  "40_FEET_HIGH_CUBE",
  "8_FEET",
  "10_FEET"
]

const cargoTypeNeedsContainerNo = (cargoType: CargoType) => {
  return cargoTypesWithContainerNo.includes(cargoType)
};

export default cargoTypeNeedsContainerNo;